module.exports = __webpack_public_path__ + "static/media/05-full.408a2be2.jpg";